export const LegendOffset = 100;
export const DarkTextColor = 'rgba(255, 255, 255, 0.59)';
export const LightTextColor = 'rgba(0, 0, 0, 0.59)';
export const DashedGridSize = '2 3';
export const DarkDashedGridColor = 'rgba(255, 255, 255, 0.1)';
export const LightDashedGridColor = 'rgba(0, 0, 0, 0.1)';
export const LegendFontSize = 14;
export const AxisTickSize = 0;
export const AxisTickPadding = 16;
